module.exports = {
      id: "comm-lifestyle-usage",
      viewBox: "0 0 294 59.387",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-lifestyle",
      toString: function () {
        return this.url;
      }
    }